/* eslint-disable jsx-a11y/anchor-is-valid */
import {useLocation, useNavigate} from "react-router-dom"
import {observer} from "mobx-react"
import {useRootStore} from "store/useRootStore"
import {getLocalAccessTokenInfo, setLocalAccessToken} from "lib/http/token-management"
import {authAxios} from "lib/http/http.common"
import {useFindUserInfo} from "hooks/queries/auth.query"

const adminButtonWidth = 100
export const Top = observer(() => {
    const {
        dashboardStore: {
            searchKeyword,
            setSearchKeyword,
            showTtlDeviceStatus,
            showDeviceStatusInfoList,
            showStatusChart,
            setShowStatusChart,
            setShowDeviceStatusInfoList,
            setShowTtlDeviceStatus
        }
    } = useRootStore()
    const tokenInfo = getLocalAccessTokenInfo()
    const {data: userInfoData} = useFindUserInfo(tokenInfo)
    const navigate = useNavigate()
    const location = useLocation()
    const userInfo = userInfoData?.body
    const isAdminPage = location.pathname.includes("/admin")
    const logout = async () => {
        const tokenInfo = getLocalAccessTokenInfo()
        const refreshToken = tokenInfo?.refresh_token
        if (refreshToken) {
            await authAxios.post("/auth/logout", {
                refreshToken,
            })
            await setLocalAccessToken(null)
            navigate("/login")
        }
    }
    return (
        <div className="main-top">
            <nav className="topnav">
                <div className="topnav-brand is-clickable" onClick={() => {
                    navigate("/")
                    // window.location.href = "/"
                }}>
                    전동휠체어 추적감지 시스템
                </div>

                <div className="topnav-menu">
                    <div className="topnav-start">
                        <div className="topnav-item" style={{display: isAdminPage ? "none" : "block"}}>
                            <div className="input-search-box4 ml10">
                                <div className="btn-search">
                                    <i className="fa fa-search"/>
                                </div>
                                <input className="input input-search" type="text" placeholder="사용자명 또는 통신장치 EUI"
                                       defaultValue={searchKeyword}
                                       onChange={(e) => setSearchKeyword(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="topnav-end">
                        <div className="topnav-item">
                            <span className={`tag is-clickable ${showTtlDeviceStatus ? 'is-primary' : ''}`}
                                  onClick={() => setShowTtlDeviceStatus(!showTtlDeviceStatus)}>
                                디바이스 통계 보이기
                            </span>
                            <span className={`tag is-clickable ${showDeviceStatusInfoList ? 'is-primary' : ''} ml-2`}
                                  onClick={() => setShowDeviceStatusInfoList(!showDeviceStatusInfoList)}>
                                디바이스 목록 보이기
                            </span>
                            <span className={`tag is-clickable ${showStatusChart ? 'is-primary' : ''} ml-2`}
                                  onClick={() => setShowStatusChart(!showStatusChart)}>
                                이벤트 현황 보이기
                            </span>
                        </div>
                        <div className="topnav-item">
                            <div className="member-box">
                                <div className="membericon">
                                    <img src="/img/member-icon.png" alt="" className="icon-img"/>
                                </div>
                                <div
                                    className="membertext">{userInfo?.name || userInfo?.givenName || userInfo?.preferredUsername}님<br/>
                                    안녕하세요
                                </div>
                            </div>
                        </div>
                        <div className="topnav-item">
                            <div className="buttons">
                                {isAdminPage && (
                                    <a className="button is-outlined is-rounded is-size-85 is-White"
                                       style={{width: adminButtonWidth}}
                                       onClick={() => {
                                           navigate("/")
                                           // window.location.href = "/"
                                       }}
                                    >Dashboard</a>
                                )}
                                {!isAdminPage && (
                                    <a className="button is-outlined is-rounded is-size-85 is-White"
                                       style={{width: adminButtonWidth}}
                                       onClick={() => {
                                           navigate("/admin")
                                           // window.location.href = "/admin"
                                       }}
                                    >admin</a>
                                )}

                                <a className="button is-outlined is-rounded is-size-85 is-White" onClick={() => {
                                    logout()
                                }}>Logout</a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
})
